import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import Publish from '../views/Publish.vue';
import Video from '../views/Video.vue';
import StoryPub from '../views/StoryPub.vue';
import StoryManage from '../views/StoryManage.vue';
import VueWechatTitle from 'vue-wechat-title';

Vue.use(Router);
Vue.use(VueWechatTitle);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Publish',
      component: Publish,
      meta: {
        requiresAuth: true,
        title: '山海-精卫计划创作者中心',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '山海-精卫计划创作者中心',
      },
    },
    {
      path: '/video/:status',
      name: 'Video',
      component: Video,
      meta: {
        title: '山海-精卫计划创作者中心',
      },
    },
    {
      path: '/publish',
      name: 'Publish',
      component: Publish,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/edit/:vid/:status',
      name: 'Edit',
      component: Publish,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/story-publish',
      name: 'StoryPub',
      component: StoryPub,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/story-manage/:status',
      name: 'StoryManage',
      component: StoryManage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/edit-story/:vid/:status',
      name: 'StoryEdit',
      component: StoryPub,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

// 导航守卫：未登录用户不能访问主页
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token'); // 假设token存储在localStorage
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      console.log('/login');
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
